<div class="progress-spinner-wrap progress-spinner-wrap--stacked">
  <mat-progress-spinner [diameter]="diameter"
                        [strokeWidth]="strokeWidth"
                        [mode]="'determinate'"
                        [value]="100">
    <!-- keep this value at 100; it works as a background -->
  </mat-progress-spinner>
  <mat-progress-spinner [diameter]="diameter"
                        [strokeWidth]="strokeWidth"
                        [mode]="'determinate'"
                        [value]="value"
                        #progressTooltip="matTooltip"
                        (click)="progressTooltip.toggle()"
                        matTooltip="{{value | number:'1.2-2' }}% complete">
    <!-- these last 2 values can be changed to correspond with progress -->
  </mat-progress-spinner>
</div>
